export default __webpack_public_path__ + "static/media/class_lawenforcement.997edab1.png";